export default function SchedulerRuntimeMessage({technicalDetail, isFailure = true, t}) {
    return (
        <div className={"max-w-md space-y-2 text-xs " + (isFailure ? "text-datixo-negative" : "text-amber-800 dark:text-amber-200")}>
            {isFailure && (
                <div>
                    {t("runtime.scheduler.safe_failure_message", {
                        defaultValue: "Data se nepodařilo aktualizovat. Zkontrolujte stav připojení a přístup ke zdroji dat.",
                    })}
                </div>
            )}
            <details className={"app-surface rounded-md border border-slate-300 bg-white/70 px-2.5 py-2 text-slate-700 dark:border-slate-600 dark:bg-slate-900/40 dark:text-slate-200"}>
                <summary className={"cursor-pointer font-semibold"}>
                    {isFailure
                        ? t("runtime.scheduler.technical_detail", {defaultValue: "Technický detail"})
                        : t("runtime.scheduler.additional_detail", {defaultValue: "Doplňující informace"})}
                </summary>
                <div className={"mt-2 whitespace-pre-wrap break-words font-mono text-[11px] leading-relaxed"}>
                    {technicalDetail}
                </div>
            </details>
        </div>
    );
}
